import { FaCode } from 'react-icons/fa';
import { PortfolioViewMain } from '../Components/PortfolioViewMain';

export const PortfolioModule = (DATA_USER_AUTH = null) => [
    {
        views: 'PUBLIC',
        path: '/',
        component: <PortfolioViewMain />,
        roles: null,
        permissions: null,
        label: 'Portfolio',
        icon: <FaCode />,
        displayInHeader: false,
        displayInFooter: false,
        displayInSidebar: false,
        isBlockedWhenLogged: false,
        scrollToItems: [
            { id: 'sobre-mi', label: 'Sobre mi' },
            { id: 'proyectos', label: 'Proyectos' },
            { id: 'experiencia', label: 'Trayectoria' },
            { id: 'blog', label: 'Blog' },
        ],
    },
];
